const CapabilityCards = () => {
    const cardList = document.querySelector('.capability-cards__list');
    const loadMorCard = document.querySelector('.capability-cards__load-more-item');

    if (!loadMorCard || !cardList) return;

    let isRequestInProgress = false; 

    loadMorCard.addEventListener('click', () => {
        if (isRequestInProgress) return; 

        isRequestInProgress = true; 

        const ajaxData = JSON.parse(loadMorCard.getAttribute('data-ajax-data'));

        fetch(scripts_data.ajax_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'load_more_services',
                ajax_data: JSON.stringify(ajaxData),
            }),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    cardList.insertAdjacentHTML('beforeend', data.data.html);
                    loadMorCard.remove();
                } else {
                    console.error('Error:', data.message);
                }
            })
            .catch((error) => console.error('Error:', error))
            .finally(() => {
                isRequestInProgress = false; 
            });
    });
};

export default CapabilityCards;